<template>
  <div class="dashboard-entities-no-results no-hover">
    <span class="dashboard-entities-no-results-text">No matches found</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DashboardEntitiesNoResults',
})
</script>
<style lang="scss">
.dashboard-entities-no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 56px;
  margin-bottom: 58px;
  overflow: hidden;
  text-align: center;

  @include media-breakpoint-up(lg) {
    margin-top: 12px;
  }

  &-text {
    @include lettering--p;
    color: var(--color-text-primary);
  }
}
</style>
